var AWS = require('aws-sdk');
var config = require("./config")

export default AWS